import { graphql } from '@prophecy/graphql-types/graphql';
import { getUserFabricFields } from '../../data/apis/getUserFabricFields';
export const UpdateOnboardingStatusMutation = graphql(`
  mutation UpdateOnboardingStatusMutation($lastFlowCompleted: String, $lastFlowCompletedSql: String) {
    updateLastFlowCompletedOnboarding(
      lastFlowCompleted: $lastFlowCompleted
      lastFlowCompletedSql: $lastFlowCompletedSql
    )
  }
`);
export function getQuery(isSqlProject, hasAirflow) {
    return graphql(`
  query OnboardingEntitiesQuery($uid: String!) {
    User(uid: $uid) {
      onboardingEntities {
        datasetDirectoryPath
        lastFlowCompleted
        lastFlowCompletedSql
        sqlProject{
            _id
            industry
        }
        sqlFabric{
            ${getUserFabricFields(isSqlProject, hasAirflow)}
        }
        project {
          pipelines {
            _id
            name
          }
        }
        fabric {
          ${getUserFabricFields(isSqlProject, hasAirflow)}
        }
        analystFabric{
          ${getUserFabricFields(isSqlProject, hasAirflow)}
        }
        analystProject {
            _id
        }
      }
    }
  }
`);
}
